import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import * as ReactDOM from "react-dom";
import OrganizationTreeList from "../Dashboard/OrganizationTreeList";
import { CircularProgress, Select } from "@material-ui/core";
import Api from "../../Services/Api";
import { toastr } from "react-redux-toastr";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import WorkStreamWithRoles from "../Dashboard/WorkStreamWithRoles";
import { filterBy } from "@progress/kendo-data-query";


export default class AddUserControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      selectedOrgUnit: [],
      ownerList: [],
      orgunitIds: [],
      OrgUnitIds: [],
      Isfiltered:false,
      dropdownList:"",
      roleArrayRisk:[],
      roleArrayTask:[]
    };
  }
  componentDidMount() {
    this.isAuthorizeUse();
  }
  isAuthorizeUse = () => {
    // if (!secureLocalStorage.getItem("loginUserId")) {
    //   let token =
    //     secureLocalStorage.getItem("loggedClient") == "user"
    //       ? secureLocalStorage.getItem("userKey")
    //       : secureLocalStorage.getItem("tenantKey");
    //   let loggedClient = secureLocalStorage.getItem("loggedClient");
    //   this.props.history.push({
    //     pathname: `/${loggedClient}/${token}/unauthorized`,
    //   });
    // } else {
      this.getOrganizationsUnits();
      this.getUsersWithoutPMO();
    // }
  };

  getUsersWithoutPMO = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      let response = await Api.GetUsersWithoutPMO(request);
      if (response.status === 200 && response.tenantUsers) {
        var tempUserList = [];
        for (var i = 0; i < response.tenantUsers.length; i++) {
          tempUserList.push({
            value: response.tenantUsers[i].userId,
            text: response.tenantUsers[i].name,
            workStreamIds: response.tenantUsers[i].workStreamIds,
            workstreamRoles: response.tenantUsers[i].workstreamRoles,
          });
        }
        this.setState({
          ...this.state,
          ownerList: tempUserList,
          loader: false,
        });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      toastr.error("Failed");
      console.error(error);
    }
  };
  getOrganizationsUnits = async () => {
    try {
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getOrgUnits(request, "PMO");
      if (response.status == 200) {
        this.setState({ ...this.state, loader: false });
        this.setState({
          ...this.state,
          workstreamData: response.organisationUnit,
        });
      } else {
        this.setState({ ...this.state, loader: false });
        this.setState({ ...this.state, workstreamData: [] });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };

  getRiskList = async (orgUnitListIds) => {
    if (orgUnitListIds && orgUnitListIds.length > 0) {
      this.setState({
        ...this.state,
        OrgUnitIds: orgUnitListIds,
      });
    }
  };
  setEmptyRiskList = async (ids) => {
    this.setState({
      ...this.state,
      OrgUnitIds: [],
    });
  };
  assignWorkstreamToUser = async () => {
    try {
      let orgunitIds=this.constructWorkstreamRoleJson(this.state.roleArrayRisk,this.state.roleArrayTask);
      // let roleFlag=this.areAllKeysFilled(orgunitIds);
      // if ( !roleFlag) {
      //   toastr.error("Please select role for all the workstreams");
      //   return;
      // }
    
      var loggedClient = secureLocalStorage.getItem("loggedClient");
      var createdby =
        loggedClient == "user"
          ? secureLocalStorage.getItem("userId")
          : secureLocalStorage.getItem("tenantId");
      var request = {
        CreatedBy: parseInt(createdby),
        UserId: this.state.user.value,
        Name: this.state.user.text,
        workStreamIds: this.state.OrgUnitIds,
        orgunitIds: orgunitIds,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.PmoUserUpdate(request);
      if (response.status == 200) {
        toastr.success(response.message);
        this.setState({ ...this.state, loader: false });
        this.cancel();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
      console.error(error);
    }
  };
  cancel = () => {
    const token =
      secureLocalStorage.getItem("loggedClient") == "user"
        ? secureLocalStorage.getItem("userKey")
        : secureLocalStorage.getItem("tenantKey");
    const loggedClient = secureLocalStorage.getItem("loggedClient");
    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/admin`,
    });
  };

  selectUser = (e) => {
    // let user = e.target.value;
    // let ids = [];
    // for (var i = 0; i < user.workstreamRoles.length; i++) {
    //   ids.push(user.workstreamRoles[i].workstreamId);
    // }
    this.setState({
      user: e.target.value,
      // workstreamRoles: user.workstreamRoles,
      // OrgUnitIds: ids,
    });

    // this.refs.child.refreshData(e.target.value.workStreamIds);

    // this.refs.child.refreshData(ids);
    // setTimeout(() => {
    //   this.refs.child.refreshRole(user.workstreamRoles);
    // }, 1000);
  };
  saveRoleWithOrgId = (data) => {
    console.log("&&", data);
    this.setState({ ...this.state, orgunitIds: data });
  };
  handlefilter=(event,dropdown)=>{
    
    const element=dropdown.slice();
    const value=event.filter
   const filteredData=filterBy(element,value)  
    console.log("filtereddata",filteredData)
    this.setState({
      // ownerList :filteredData,
      Isfiltered:true,
      dropdownList:filteredData
    })

  }
  constructWorkstreamRoleJson = (arr1, arr2) => {
    const merged = arr1.map(item1 => {
        const match = arr2.find(item2 => item2.id === item1.id);
        return match ? { id: item1.id, role: item1.role, taskRole: match.taskRole } : item1;
    });

    // Add items from arr2 that are not in arr1
    const unmatched = arr2
        .filter(item2 => !arr1.some(item1 => item1.id === item2.id))
        .map(item2 => ({ id: item2.id, taskRole: item2.taskRole })); // Ensuring format consistency

    return [...merged, ...unmatched];
};
  areAllKeysFilled = (array) => {
    const requiredKeys = ['id', 'taskRole', 'role'];
    return array.every(obj =>
      requiredKeys.every(key => obj.hasOwnProperty(key) && obj[key] !== undefined && obj[key] !== null && obj[key] !== '')
    );
  };
  saveRoleWithOrgIdForRisk = (data) => {
    this.setState({ ...this.state, roleArrayRisk: data }, () => {
      console.log("roleArrayRisk", this.state.roleArrayRisk); 
    });
  };
 
  saveRoleWithOrgIdForTask = (data) => {
    this.setState({ ...this.state, roleArrayTask: data }, () => {
      console.log("roleArrayTask", this.state.roleArrayTask); 
    });
  };
  render() {
    const list= this.state.ownerList ;
    return (
      <div className="appCont">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <div className="mainWrapper">
          <div className="rm-tanent-cont">
            <div className="rm-form-cont relPosition">
              <h6>Manage User</h6>

              <form name="form">
                <div className="rm-form">
                  <div className="rm-field-container rm-service-plan">
                    <label>Select User</label>

                    <DropDownList
                      style={{ width: "100%" }}
                      onChange={(e) => this.selectUser(e)}
                      value={this.state.user}
                      data={
                        this.state.Isfiltered===true?this.state.dropdownList:this.state.ownerList}
                      valueField="value"
                      textField="text"
                      filterable={true}
                      onFilterChange={(e)=>this.handlefilter(e,list)}
                    />
                    <div className="errorMsg"></div>
                  </div>
                  </div>
                  <div className="rm-form">
                  <div className="rm-field-container-50 rm-service-plan" style={{width:'100%'}}>
                    <label>Select Workstream</label>
                    <div className="selectWorkStream">
                    <WorkStreamWithRoles
                      {...this.props}
                      selectedOrgUnit={this.state.selectedOrgUnit}
                      orgUnitData={this.state.workstreamData}
                      getRiskList={this.getRiskList}
                      getEmptyRiskList={this.setEmptyRiskList}
                      saveRoleWithOrgIdForRisk={this.saveRoleWithOrgIdForRisk}
                      saveRoleWithOrgIdForTask={this.saveRoleWithOrgIdForTask}
                      isTenent={false}
                      ref="child"
                    />
                    </div>
                  </div>
                </div>
                  
                <div className="btn-group">
                  <button
                    type="button"
                    onClick={this.assignWorkstreamToUser}
                    className="rm-btn-primary"
                  >
                    Assign
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    onClick={this.cancel}
                    className="rm-btn-primary cancelImpacts"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
